// naechste_schritte_split — paper left with exactly three numbered steps, image right from
// x640 (v15 slide 13: steps at y214/330/446 with rules between, mono footline at y620).
import type { NaechsteSchritteSplitContent } from '../../../../shared/deckTypes.js';
import { Abs, Brand, Dkp, Eyebrow, PageNo, Rule, FramedImg, splitXOf } from './chrome.js';

const STEP_Y = [214, 330, 446];

export default function NaechsteSchritteSplitPreview({ content, pageNo }: {
  content: NaechsteSchritteSplitContent;
  pageNo?: number | null;
}) {
  const c = content;
  const steps = (c.steps ?? []).slice(0, 3);
  const splitX = splitXOf(c as Record<string, unknown>, 640);
  const colW = splitX - 64 - 56;

  return (
    <Dkp>
      <Eyebrow text={c.eyebrow ?? ''} />
      <Abs x={64} y={96} w={colW}>
        <div className="dkp-title" style={{ fontSize: 30 }}>
          {c.title}
          {c.title ? <span style={{ color: '#C8A96E' }}> ●</span> : null}
        </div>
      </Abs>

      {steps.map((s, i) => {
        const y = STEP_Y[i];
        return (
          <div key={i}>
            <Abs x={64} y={y + 4} w={40}>
              <span className="dkp-mono" style={{ fontSize: 12, fontWeight: 500, color: '#8A6F3E' }}>
                {String(i + 1).padStart(2, '0')}
              </span>
            </Abs>
            <Abs x={108} y={y - 4} w={colW - 44}>
              <div className="dkp-serif" style={{ fontSize: 20 }}>{s.title}</div>
            </Abs>
            <Abs x={108} y={y + 28} w={colW - 48}>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#3A3D42', lineHeight: 1.5 }}>{s.body}</div>
            </Abs>
            <Rule x={64} y={y + 92} w={colW} />
          </div>
        );
      })}

      {c.footer_mono ? (
        <Abs x={64} y={620} w={colW}>
          <span className="dkp-footline">{c.footer_mono}</span>
        </Abs>
      ) : null}

      {/* right-hand image, full height from the split edge (v15: x640) */}
      {c.image ? (
        <Abs x={splitX} y={0} w={1280 - splitX} h={720} style={{ overflow: 'hidden' }}>
          <FramedImg src={c.image} content={c as Record<string, unknown>} slotKey="image" />
        </Abs>
      ) : null}

      <Brand />
      <PageNo n={pageNo} light={!!c.image} />
    </Dkp>
  );
}
